import React from "react";
import { Footer, StartzoneHeader } from "../../components";

import styles from "./styles.module.css";
import StartupIgnite from "../../pages/startZone/components/ignite";

const StartzoneLayout = ({ children }) => {
  return (
    <>
      <StartupIgnite/>
    <div className={`${styles.container} container`}>
      <StartzoneHeader />
      <div className={styles.children}>{children}</div>
      <Footer />
    </div>
    </>
  );
};

export { StartzoneLayout };
